// extracted by mini-css-extract-plugin
export default {"wrapper":"ThemeSwitch_wrapper__Ilrbf","icon":"ThemeSwitch_icon__u9idf","switch":"ThemeSwitch_switch__T3ROm","slider":"ThemeSwitch_slider__uyZvF"};